const ASSET = {
  LOGO_CREATORY: "images/logo-creatory.svg",
  HERO_1: "images/hero-1.svg",
};

export default ASSET;
